/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Leveling_AnnounceInputs */



/**
* | output |
* | --- |
* | "Level-up announcements, /rank and /leaderboard" |
*
* @param {Pricing_Compare_Leveling_AnnounceInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_leveling_announce = /** @type {((inputs?: Pricing_Compare_Leveling_AnnounceInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Leveling_AnnounceInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объявления о повышении уровня, /ранг и /лидеры")
	return /** @type {LocalizedString} */ ("Level-up announcements, /rank and /leaderboard")
});